import _ from 'lodash';
import axios from 'axios';
import { PAYMENT_PROVIDER } from 'shared/constants/payments';
import settings from 'shared/settings';
import { post } from 'transport/utils/http';

const { paypal: DGS_HOST } = settings.hosts;

const APIUrls = {
  config: `${DGS_HOST}vod/pp/permissions/info`,
  order: `https:${DGS_HOST}vod/cashier/order`,
  status: (order, transaction) => `https:${DGS_HOST}vod/cashier/order/${order}/transaction/${transaction}/status`,
};

function groupByProvider(paymentMethods) {
  return _.groupBy(paymentMethods, provider => (
    _.get(provider, 'connectedProviderId') === 'DGS' ?
      PAYMENT_PROVIDER.PAYPAL : PAYMENT_PROVIDER.CASHIER));
}

/**
 * Get payment configuration
 * @param {string} instance
 * @return {Promise<{cashier: any, payPal: any}>}
 */
export function getConfig(instance) {
  return axios.get(APIUrls.config, { params: { instance } })
    .then(({ data }) => groupByProvider(data.paymentMethods));
}

/**
 * Create order object
 * @param {object} params
 * @param {string} params.instance
 * @param {string} params.paymentType
 * @param {string} params.channelId
 * @param {?string} params.videoId
 * @returns {Promise}
 */
export function createOrder({ instance, paymentType, channelId, videoId }) {
  return post(APIUrls.order, {
    params: { instance },
    data: {
      channelId,
      refItemId: videoId,
      type: paymentType,
    },
    options: {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
    },
  }).then(({ data }) => ({
    paymentType, channelId, videoId,
    orderId: data.order.id,
  }));
}

/**
 * Get payment status from DGS
 * @param {object} params
 * @param {string} params.orderId
 * @param {string} params.transactionId
 * @param {string} params.instance
 * @returns {Promise<string>}
 */
export function getPaymentStatus({ orderId, transactionId, instance }) {
  const url = APIUrls.status(orderId, transactionId);
  const config = {
    params: { instance },
    withCredentials: true,
    xsrfCookieName: null,
    xsrfHeaderName: null,
  };
  return axios.get(url, config)
    .then(response => ({ status: response.data.status }));
}



// WEBPACK FOOTER //
// ./src/api/payments/dgs.js